import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
const PublicLayout = () => {
  return (
    <main>
      <Suspense>
        <Outlet />
      </Suspense>
    </main>
  )
}

export default PublicLayout
